var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 35,
    viewBox: "0 0 56 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 33.4258L19.6185 25.1907C20.3426 24.8704 20.8095 24.1533 20.8095 23.3616V4.35606C20.8095 2.94755 22.2267 1.98031 23.5383 2.49357L37.0404 7.77697C37.8178 8.08121 38.3246 8.83641 38.3113 9.6712L38.0063 28.8893C37.9821 30.4129 39.6026 31.4028 40.9472 30.6857L55.0952 23.1401",
    stroke: "#777E82",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD10);
export default __webpack_public_path__ + "static/media/d10.54558fedaab433299bc8eca44de77394.svg";
export { ForwardRef as ReactComponent };